// Subscription type based on pricePlan
// returns an empty string for undefined/null value or empty string
// returns monthly if contains Monthly, otherwise returns annual.
export const getSubscriptionType = (pricePlan = '') => {
  if (!pricePlan || pricePlan === '') {
    return '';
  } else {
    return pricePlan?.includes('Monthly') ? 'monthly' : 'annual';
  }
};
